<template>
    <footer>
        <!-- footer-area-start -->
        <div class="it-footer-area it-footer-bg it-footer-style-5 black-bg pb-70"
            data-background="/img/footer/bg-1-1.jpg">
            <div class="it-footer-border">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div class="it-footer-top-info d-flex align-items-center it-footer-top-col-1">
                                <div class="it-footer-top-icon">
                                    <span><i class="fa-light fa-location-dot"></i></span>
                                </div>
                                <div class="it-footer-top-text">
                                    <span>Address:</span>
                                    <a href="#">Santoshi Mata Mandir Road, Near New High School, Malhar Nagar,
                                        Joshibaug, Kalyan(W)-421 301</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div class="it-footer-top-info d-flex align-items-center it-footer-top-col-2">
                                <div class="it-footer-top-icon">
                                    <span><i class="fa-light fa-phone phone"></i></span>
                                </div>
                                <div class="it-footer-top-text">
                                    <span>Phone:</span>
                                    <a href="tel:9619392909">9619392909/9920892909</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div
                                class="it-footer-top-info d-flex align-items-center justify-content-md-end border-none it-footer-top-col-3">
                                <div class="it-footer-top-icon">
                                    <span><i class="fa-light fa-envelope"></i></span>
                                </div>
                                <div class="it-footer-top-text">
                                    <span>Email:</span>
                                    <a href="mailto:info@aime.ac.in">info@aime.ac.in</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="it-footer-wrap pt-120">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-50">
                            <div class="it-footer-widget footer-col-5">
                                <div class="it-footer-text pb-5">
                                    <p>Achievers Institute of Managment and Entrepreneurship</p>
                                    <p>Approved by AICTE- New Delhi, D.T.E Govt. of Maharashtra
                                    And Affiliated to Univertiy of Mumbai</p>
                                    <p>DTE Code : 03689</p>
                                </div>
                                <div class="it-footer-social">
                                    <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
                                    <a href="#"><i class="fa-brands fa-instagram"></i></a>
                                    <a href="#"><i class="fa-brands fa-pinterest-p"></i></a>
                                    <a href="#"><i class="fa-brands fa-twitter"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50"></div>
                        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-8 mb-50"> </div>
                        <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 mb-50">
                            <div class="it-footer-widget footer-col-6">
                                <h4 class="it-footer-title">Quick Links:</h4>
                                <div class="it-footer-list">
                                    <ul>
                                        <li><a href="#"><i class="fa-regular fa-angle-right"></i>Why AIME</a></li>
                                        <li><a href="#"><i class="fa-regular fa-angle-right"></i>Admission</a></li>
                                        <li><a href="#"><i class="fa-regular fa-angle-right"></i>Courses</a></li>
                                        <li><a href="#"><i class="fa-regular fa-angle-right"></i>Eligiblity</a></li>
                                        <li><a href="#"><i class="fa-regular fa-angle-right"></i>Contact</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <!-- footer-area-end -->

        <!-- copy-right area start -->
        <div class="it-copyright-area it-copyright-height">
            <div class="container">
                <div class="row">
                    <div class="col-12 wow itfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
                        <div class="it-copyright-text text-center">
                            <p>Copyright © 2025 <a href="#">Achievers Institute of Management & Entrepreneurship </a> || Powered by eShala</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- copy-right area end -->

    </footer>

</template>
<script>
export default {
    name: "AppFooter",
};
</script>